module.exports = __webpack_public_path__ + "fonts/iconfont.4929a7fc.ttf";